module.exports = __webpack_public_path__ + "public/images/prizes/prize-thailand.0ae2d1f68ae2cd87bfc5563d4e1da74d.png";